import React,{ useState } from 'react';
import './nav.css';
import {AiOutlineHome} from 'react-icons/ai';
import {AiOutlineUser} from 'react-icons/ai';
import {BiBook} from 'react-icons/bi';
import {FiMessageSquare} from 'react-icons/fi';
import {RiContactsBook2Line} from 'react-icons/ri';
import {VscPreview} from 'react-icons/vsc';



const Nav = () => {
  const [activeNav, setActiveNav]  = useState('#');
  return (
    <nav>
      <a href="#" onClick={()=>setActiveNav('#')} className={activeNav === '#' ? 'active' : ''}><AiOutlineHome/></a>
      <a href="#about" onClick={()=>setActiveNav('#about')} className={activeNav === '#about' ? 'active' : ''}><AiOutlineUser/></a>
      <a href="#experience" onClick={()=>setActiveNav('#experience')} className={activeNav === '#experience' ? 'active' : ''}><BiBook/></a>
      <a href="#portfolio" onClick={()=>setActiveNav('#portfolio')} className={activeNav === '#portfolio' ? 'active' : ''}><FiMessageSquare/></a>
      <a href="#testimonials" onClick={()=>setActiveNav('#testimonials')} className={activeNav === '#testimonials' ? 'active' : ''}><VscPreview/></a>
      <a href="#contact" onClick={()=>setActiveNav('#contact')} className={activeNav === '#contact' ? 'active' : ''}><RiContactsBook2Line/></a>
      
    </nav>
  )
}

export default Nav